module.exports = __webpack_public_path__ + "img/4.7.Chla.e40a1fbd.png";